/* eslint-disable */
import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import {
  IGetOfferFromHistoryWebRequest,
  TGetOfferFromHistoryWebModel,
  IMappers,
  TGetOfferFromHistoryWebResponse,
} from './types';
import { IOfferFromHistoryResponseV2Schema } from '../../entities/offer_from_history/OfferFromHistoryResponseV2Schema';
import { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export const defaultConfig: TGetOfferFromHistoryWebModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'valuation-offer-history',
  pathApi: '/v2/get-offer-from-history-web/',
  responseType: 'json',
} as TGetOfferFromHistoryWebModel;

export function createGetOfferFromHistoryWebModel(
  parameters: IGetOfferFromHistoryWebRequest,
): TGetOfferFromHistoryWebModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetOfferFromHistoryWebOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetOfferFromHistoryWebRequest;
}

export async function fetchGetOfferFromHistoryWeb<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetOfferFromHistoryWebOptions<TResponse200, TResponse400>): Promise<
  TGetOfferFromHistoryWebResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetOfferFromHistoryWebModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IOfferFromHistoryResponseV2Schema);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetOfferFromHistoryWebResponse;
}
